import { createRenderTarget } from '../../render-target'

import { NavItem } from '@news-mono/web-common'
import { NavEvent } from '@news-mono/web-common'
import { QuickLinksWeb } from './QuickLinks.web'

export interface QuickLinksProps {
    links: NavItem[]
    onEvent: (event: NavEvent) => void
    hasBackgroundFill?: boolean
}

export const QuickLinks = createRenderTarget('QuickLinks', {
    web: QuickLinksWeb,
    amp: QuickLinksWeb,
    rss: QuickLinksWeb,
    preview: QuickLinksWeb,
    app: null,
})
QuickLinks.displayName = 'QuickLinks'
